import React, {useEffect, useState} from "react";
import {Col, Input, message, Modal, Row} from "antd";
import '../../../ModalStyle.css';

const rowStyle = {padding: '8px'};

export default function ExpenseCategoryEditDialog({visible, expenseCategory, onOk, onCancel, title}) {
  let [record, setRecord] = useState({id: 0});

  useEffect(() => {
    if(expenseCategory) {
      setRecord({
        id: expenseCategory.id,
        title: expenseCategory.title || "",
      });
    } else {
      setRecord({id: 0});
    }
  }, [expenseCategory]);

  return (
    <Modal
      destroyOnClose={true}
      className="size-for-small-window"
      title={title || "Новая запись"}
      visible={visible}
      onOk={() => {
        if(!record.title) {
          message.warn("Укажите наименование");
          return;
        }
        onOk(record);
        setRecord({id: 0});
      }}
      onCancel={onCancel}>

      <Row gutter={[0, 16]} style={rowStyle}>
        <Col span={6}>Наименование</Col>
        <Col span={18}>
          <Input
            allowClear={true}
            placeholder="Наименование"
            value={record.title}
            onChange={(e) => { setRecord({...record, title: e.target.value}) }}/>
        </Col>
      </Row>
    </Modal>
  );
}